const envs = [
    {
        "env": "prod",
        "endpoint": "/ec2",
        "api_url": "https://4iwxvi4en5.execute-api.eu-west-1.amazonaws.com/prod",
        "description": "Sandbox Dashboard - Production",
        "justifications": [
            "Cloud Migration",
            "Fodina Request",
            "Onboarding",
            "T1-T2 Highly Active",
            "Targets Migration",
            "Testing-Configurations",
            "Standard Under 72 Hours"
            ]
    },
    {
        "env": "qa",
        "endpoint": "/qa",
        "api_url": "https://sklltoerv5.execute-api.eu-west-1.amazonaws.com/prod",
        "description": "EC2 Dashboard - Staging",
        "justifications": [
            "Standard - under 72 Hours",
            "Long Term"
        ]
    }
]



export {envs}